import { get, post, putData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./idea-comment.serializer";

export const getIdeaComments = async (
  token,
  baseUrl,
  projectId,
  brainstormerId,
  ideaId,
  params = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/brainstormers/${brainstormerId}/ideas/${ideaId}/comments`;
  try {
    const res = await get(token, queryPath, params);
    return await deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const postIdeaComment = async (
  token,
  baseUrl,
  projectId,
  brainstormerId,
  ideaId,
  body = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/brainstormers/${brainstormerId}/ideas/${ideaId}/comments`;
  try {
    const serializedBody = await serialize(body);
    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const editIdeaComment = async (
  token,
  baseUrl,
  projectId,
  brainstormerId,
  ideaId,
  commentId,
  body = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/brainstormers/${brainstormerId}/ideas/${ideaId}/comments/${commentId}`;

  const serializedBody = await serialize(body);

  return putData(token, queryPath, {}, serializedBody).then((res) =>
    deserialize(res.data)
  );
};
